import { IVendorInvoiceDetails } from "../../InvoiceCapture/types";
import { atom } from "recoil";
import { SelectedRows } from "../types";

export const forEdit = atom<IVendorInvoiceDetails | undefined>({
  key: "forEdit",
  default: undefined,
});

export const isEditStateForReview = atom({
  key: "isEditStateForReview",
  default: false,
});

export const selectedRowsForReview = atom<SelectedRows>({
  key: "selectedRowsForReview",
  default: [],
});

export const isRecallInvoice = atom({
  key: "isRecallInvoice",
  default: false,
});

export const isDenyInvoice = atom({
  key: "isDenyInvoice",
  default: false,
});

export const isApprovedInvoice = atom({
  key: "isApprovedInvoice",
  default: false,
});

export const defaultForReviewSearchData = atom({
  key: "defaultForReviewSearchData",
  default: {
    StoreNumber: "",
    ServiceAccountNo: "",
    BatchNo: 0,
    TaxId: "",
    DateCreatedFrom: "",
    DateCreatedTo: "",
    Status: "For Review",
  },
});

export const forReviewData = atom({
  key: "forReviewData",
  default: undefined,
});
